import Yup from 'utils/yup'

export const defaultValues = {
  maintenanceInspectionId: null,
}

export const validationSchema = Yup.object().shape({
  maintenanceInspectionId: Yup.string().nullable().required(),
})
